import { apiService } from '@/api/apiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

type SetPasswordPayloadType = {
  password: string;
};

export const setPasswordApi = async (
  userId: string,
  token: string,
  data: SetPasswordPayloadType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/users/${userId}/set-password/${token}/`;

  return apiService.PATCH(uri, data);
};
